import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      Open-sourced on{" "}
      <a
        href="https://github.com/Veronika-Podolska/weather_react_app"
        target="_blank"
        rel="noopener noreferrer"
      >
        GitHub
      </a>{" "}
      by Niksy
    </div>
  );
}
